"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardActions.default;
  }
});

var _CardActions = _interopRequireDefault(require("./CardActions"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/CardActions/index.js
 ** module id = 645
 ** module chunks = 0
 **/